module.exports = __webpack_public_path__ + "media/images/phone-b0db29abe0a7e97628f988a86755924b.png";